let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
import React from "ES/lib/react";

let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require('ES/widgets/forms/FormMixin');
let FormUtils = require('../../../utils/FormUtils');
let ErrorAlert = require('ES/widgets/ErrorAlert');
let SlideOpenDown = require('../../widgets/SlideOpenDown');
let HorizontalFields = require('ES/widgets/HorizontalFields');
var ServicesUtils = require('ES/utils/ServicesUtils');

let DisplayfieldsForm = dd.createClass({
    mixins: [FormMixin],

    getInitialValuesSourceVersion: function (props) {
        return props;
    },

    getInitialValues: function (props) {
        return _.get(props, "initvals", []);
    },

    buildFields: function () {
        let key;
        let fields = {};
        let data = _.get(this.state, "data", {});
        let tabs = _.get(this.props, 'config.displayfields.tabs', []);

        _.each(tabs, function (tab) {

            if (!tab.hasOwnProperty('tabtype') || !tab.hasOwnProperty('label')) return; //got some bad data to skip

            //the tab itself
            key = ["tab", tab.tabtype, "hidden"].join("|");
            fields[key] = {
                label: "Entire " + tab.label.toUpperCase() + " tab",
                type: "select",
                options: {
                    SHOW: "show",
                    HIDE: "hide"
                },
                help_text: "Do you want clients to be able to see this tab?",
                validate: FormUtils.v.required,
            };

            if (("contacts" !== tab.tabtype) && (Object.keys(_.get(tab, "fieldlist", {})).length < 2) ) return; //if there's only one field (ie, "othernote") then hiding/showing the tab itself is sufficient
            if ("HIDE" === _.get(data, [key], "SHOW")) return;  //individual fields only if the tab as a whole isn't hidden

            //fields within the tab
            _.each(_.get(tab, "fieldlist", {}), function (fielddata, fieldname) {
                    key = ["tab", tab.tabtype, "field", fieldname, "hidden"].join("|");
                    fields[key] = {
                        label: fielddata.label,
                        type: "select",
                        options: {
                            SHOW: "show",
                            HIDE: "hide"
                        },
                        validate: FormUtils.v.required
                    };

                    //if ("HIDE" === _.get(data, [key])) return;//editable control only if the field is not hidden
                    key = ["tab", tab.tabtype, "field", fieldname, "editable"].join("|");
                    fields[key] = {
                        label: "client can update",
                        type: "select",
                        options: {
                            "ALWAYS": "client can change",
                            "NEVER": "client cannot change",
                            "WHENPENDING": "when offer pending is ON"
                        },
                        validate: FormUtils.v.required
                    };
                }
            );

        });
        return fields;
    },
    __discardChanges: esUtils.wrapPreventDefault(function () {
        this._form_reset();
    }),

    render: function () {
        let fields = this.buildFields();
        let changes_made = this._form_areChangesMade();
        let error_msg = _.get(this.props, "error_msg");
        let success_msg = _.get(this.props, "success_msg");
        let parts, key2, tabtype;
        let self = this;
        let errors = this.state.errors || {};
        let tablabel;
        let layoutfields = {};


        if (_.isEmpty(fields)) return null;

        //layout the tabs and fields
        _.each(fields, function (field, key) {
            parts = key.split('|');
            tabtype = parts[parts.indexOf('tab') + 1];
            _.set(layoutfields, [tabtype, "fields", key], field);
            if (-1 === parts.indexOf('field')) {
                _.set(layoutfields, [tabtype, "layout"], _.get(layoutfields, [tabtype, "layout"], []).concat([[key, null]]));
            } else {
                if ("editable" == parts[parts.length - 1]) {
                    parts[parts.length - 1] = "hidden";
                    key2 = parts.join("|");
                    _.set(layoutfields, [tabtype, "layout"], _.get(layoutfields, [tabtype, "layout"], []).concat([[key2, key]]));
                }
            }
        });

        _.each(layoutfields, function (v, tabtype) {
            tablabel = _.result(_.find(_.get(self.props, ["config", "displayfields", "tabs"]), {"tabtype": tabtype}), "label");
            layoutfields[tabtype]["render"] = <div className="portaltab" style={{marginTop: "2em"}} key={tabtype}>
                <h4 style={{marginLeft: "2em"}}>{tablabel} tab</h4>
                {HorizontalFields({
                    fields: _.get(layoutfields, [tabtype, "fields"], []),
                    errors: errors,
                    buildInput: self._form_buildInput,
                    layout: _.get(layoutfields, [tabtype, "layout"], [])
                })
                }</div>;
        });


        return <form className='form-horizontal' onSubmit={this._form_onSubmit}>
            <h3>Choose which fields the client can see / change</h3>

            <p>
                <a href="https://espeakers.com/wiki/Client_Portal#How_do_I_choose_which_fields_my_customers_can_see_or_change.3F" target="_blank">
                    Learn more about the Client Portal  <i style={{marginLeft: "0.5em", fontSize: "1.0em"}} className="fa fa-external-link"/>
                </a>
            </p>

            {_.map(layoutfields, function (v) {
                return v["render"];
            })
            }
            {SlideOpenDown({open: changes_made},
                HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
            )
            }
            {success_msg && !changes_made &&
            <div className="alert alert-success">
                Saved.
            </div>}
            {ErrorAlert({
                message: error_msg
            })}
        </form>;
    }
});


module.exports = dd.createClass({
    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_displayfields")],

    getInitialState: function (props) {
        return {
            sid: -1,
            data: {},
            is_saving: false,
            error_msg: null,
            success_msg: null
        };
    },
    componentWillReceiveProps(props) {
        this.setState({sid: props.config.sid, config: props.config, data: this.__convertDisplayfieldsToFormData(props.config.displayfields), success_msg: null, error_msg: null});
    },

    //translate the displayfield data from xhr into the initvalues the form needs. This gets reversed in ClientportalController->convertFormDataToDisplayFields()
    __convertDisplayfieldsToFormData: function (displayfields) {
        let initvals = {sid: _.get(this.state, "sid", '')};
        let key;

        let tabs = _.get(displayfields, "tabs", []);
        _.each(tabs, function (tab) {
            key = ["tab", tab.tabtype, "hidden"].join("|");
            initvals[key] = (_.get(tab, "hidden", true)) ? "HIDE" : "SHOW";

            _.each(_.get(tab, "fieldlist", []), function (fielddata, fieldname) {
                    key = ["tab", tab.tabtype, "field", fieldname, "editable"].join("|");
                    initvals[key] = _.get(fielddata, "editable", "never").toUpperCase();
                    key = ["tab", tab.tabtype, "field", fieldname, "hidden"].join("|");
                    initvals[key] = _.get(fielddata, "hidden", true) ? "HIDE" : "SHOW";
                }
            );
        });

        return initvals;

    },

    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into DisplayfieldsForm() as a parameter
    __onSubmit: function (data) {
        let self = this;

        radio('save_ClientPortal_displayfields').broadcast(data.sid, data,
            function (sid, data) {

                //setting state.config results in new initvals being passed to DisplayfieldsForm
                if (_.get(self, "state.sid") == sid) {
                    self.setState({
                        sid: sid,
                        config: data,
                        is_saving: false,
                        error_msg: null,
                        success_msg: "Saved."
                    });
                }
            },
            function (sid, message) {
                self.setState({error_msg: message, success_msg: null});
            });
    },
    __selectTextInput: function (e) {
        e.target.setSelectionRange(0, e.target.value.length);
    },
    render: function () {
        let {speaker, Displaylists} = this.props;

        return dd.div({},
            DisplayfieldsForm({
                speaker,
                Displaylists,
                initvals: this.__convertDisplayfieldsToFormData(_.get(this.state, "config.displayfields")),
                config: _.get(this.state, "config"),
                onSubmit: this.__onSubmit,
                error_msg: _.get(this.state, "error_msg"),
                success_msg: _.get(this.state, "success_msg")
            })
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/ClientPortal/DisplayfieldsForm.js